import { Metamodel } from 'app/model/base/model';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { ParseFormat, ParseTransformation } from 'app/model/dataflow/parsetransformation';
import { FLOW } from 'app/model/adapters/dataflow/IDataflow';
import { TransformationAdapter } from 'app/model/adapters/dataflow/transformations/base-transformation.adapter';
import { ExpressionBasedColumnVisitorAdapterUtils } from '../expression-based-column-visitor-adapter.utils';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ParseTransformation),
    asynchronous: true
})
export class ParseTransformationAdapter extends TransformationAdapter<ParseTransformation> {
    public async getDslScript(parseTransformation: ParseTransformation): Promise<string> {
        const props: string[] = [];
        props.push(
            await ExpressionBasedColumnVisitorAdapterUtils.writeToDsl(
                this.context.contextData,
                parseTransformation.expressionColumns,
                parseTransformation
            )
        );
        props.push(TransformationAdapter.getPartitionDslScript(parseTransformation));
        props.push(`format: '${parseTransformation.format}'`);
        switch (parseTransformation.format) {
            case ParseFormat.json:
                props.push(
                    `documentForm: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                        parseTransformation.jsonSettings.documentForm
                    )}`
                );
                break;
            case ParseFormat.delimitedText:
                props.push(`columnNamesAsHeader: ${parseTransformation.delimitedTextSettings.columnNamesAsHeader}`);
                props.push(`columnDelimiter: '${parseTransformation.delimitedTextSettings.columnDelimiter}'`);
                props.push(`nullValue: '${parseTransformation.delimitedTextSettings.nullValue}'`);
                break;
            case ParseFormat.xml:
                if (parseTransformation.xmlSettings.nullValue) {
                    props.push(`nullValue: '${parseTransformation.xmlSettings.nullValue}'`);
                }
                props.push(`namespaces: ${parseTransformation.xmlSettings.namespaces}`);
                if (parseTransformation.xmlSettings.namespaces) {
                    const namespacePrefixes = parseTransformation.xmlSettings.namespacePrefixes
                        .filter((namespacePrefix) => namespacePrefix.key && namespacePrefix.val)
                        .map((namespacePrefix) => `'${namespacePrefix.key}'->'${namespacePrefix.val}'`)
                        .join(',');
                    if (namespacePrefixes) {
                        props.push(`namespacePrefixes: [${namespacePrefixes}]`);
                    }
                }
                break;
            default:
                break;
        }
        const knownProps = props.filter((c) => !!c).join(',\n\t');
        const unknownProps = this._getUnknownProps(parseTransformation, knownProps);
        const transformationData = [knownProps, unknownProps].filter((c) => !!c).join(',\n\t');

        return (
            `${this._getInputStreams(parseTransformation)} ${ParseTransformation.MODEL.name}(${transformationData}) ` +
            `${FLOW} ${this._getOutputStreams(parseTransformation)}`
        );
    }
}
